import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE, PRICE_BEFORE } from '../data/matikka';
const recap = ['6 osaa', '5 bonusta', '240 sivua', '1.–9. luokka'];
const reassurances = ['Välitön digitaalinen lataus', 'Tulostusvalmiit PDF:t', '7 päivän tyytyväisyystakuu'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-112" data-mp="15fghijkq710e">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-113" data-mp="1jbad60whntvk" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-114" data-mp="1t2ybmlrgqb6j">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-115" data-mp="1t253phgrpfmt">
          Matematiikka voi olla <em className="text-red-700" data-id="element-116" data-mp="223mh2s2sj37t">valmiiksi suunniteltu jo tänään.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-117" data-mp="221a1glki94xx">
          Sen sijaan, että etsit ideoita, teet jokaisen monisteen itse ja käytät sunnuntai-illat
          suunnitteluun, sinulla on selkeä paketti koko lukuvuodeksi. Enemmän aikaa sille, millä
          on oikeasti merkitystä:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-118" data-mp="x390dvx3m26f">
          Oppilaasi. Opetuksesi. Elämäsi koulun ulkopuolella.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-119" data-mp="120imp2p6xxq1">
          {recap.map(item => <li key={item} data-id="element-120" data-mp="1b31pjmsz8aca">{item}</li>)}
        </ul>

        <p className="mt-8 text-lg text-slate-900/60" data-id="element-121" data-mp="1b1grhn7ge99o">Ennen <s data-id="element-122" data-mp="1fu03wguemycw">{PRICE_BEFORE}</s></p>
        <p className="mt-2 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-123" data-mp="1fus1fx7kb65t">{PRICE}</p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-124" data-mp="1kvfq4c8bjawv">Kertamaksu – ei tilausta.</p>

        <div className="mt-8 flex justify-center" data-id="element-125" data-mp="1pu0tgkivaapj">
          <CtaButton className="w-full sm:w-auto" data-id="element-126" data-mp="1ttjctbv1idq9" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-127" data-mp="1tryjtqodj2ui">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-128" data-mp="3lvubnktrir12">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-129" data-mp="3lthpevgz1ui7" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}